import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkurkumbhmidc() {



  const cardData =
  {
    keyword: 'Cab Service in Kurkumbh MIDC',
    heading: 'Sanavi Travels: Cab Service in Kurkumbh MIDC',
    headingDescription: 'Sanavi Travels offers reliable Cab Service in Kurkumbh MIDC, providing safe, comfortable, and convenient transportation for employees, corporate travelers, factory staff, and business visitors in the Kurkumbh industrial area. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cabs ensures smooth rides, air-conditioning, and ample luggage space for hassle-free travel. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Kurkumbh MIDC and nearby areas, making it ideal for corporate travel, factory commutes, business meetings, and industrial site visits. Choose Sanavi Travels for trusted cab services in Kurkumbh MIDC, delivering comfort, safety, and reliable transportation for every professional need.',

    top: 'Top Places to Visit in Kurkumbh with Sanavi Travels',


"topPlaces": [
  {
    "title": "Kurkumbh Ganesh Temple",
    "description": "Kurkumbh is famous for its ancient Ganesh temple, dedicated to Lord Ganesha. Devotees from nearby villages and towns visit to offer prayers, especially during Ganesh Chaturthi, seeking blessings and prosperity."
  },
  {
    "title": "Local Wadis and Temples",
    "description": "The village has several small shrines and wadi temples that reflect the traditional religious and cultural practices of rural Maharashtra. These sites are visited during festivals and community celebrations."
  },
  {
    "title": "Agricultural Fields and Farms",
    "description": "Kurkumbh is surrounded by fertile agricultural lands where sugarcane, vegetables, and other crops are grown. Visitors can experience rural life and traditional farming practices in the region."
  },
  {
    "title": "Village Water Bodies",
    "description": "Local ponds and small lakes near Kurkumbh offer natural scenic beauty and serve as sources of irrigation. They are peaceful spots for relaxation and observing rural life."
  },
  {
    "title": "Kurkumbh Weekly Market",
    "description": "The weekly market in Kurkumbh is a vibrant gathering place for villagers, selling fresh produce, grains, household items, and handicrafts. It provides a glimpse into local commerce and community life."
  },
  {
    "title": "Cultural Festival Grounds",
    "description": "During local festivals, open grounds in Kurkumbh host fairs, processions, and cultural programs. These events showcase traditional music, dance, and folk arts of the region."
  },
  {
    "title": "Nearby Religious Sites",
    "description": "Kurkumbh is located near several other notable religious destinations in Pune district, making it a stop for pilgrims traveling to nearby temples and spiritual centers."
  },
  {
    "title": "Local Temples Dedicated to Village Deities",
    "description": "Small temples dedicated to village deities and protective gods can be found throughout Kurkumbh, offering insight into the spiritual life and beliefs of the local community."
  },
  {
    "title": "Rural Landscapes and Nature Trails",
    "description": "The surrounding countryside features green fields, farm roads, and natural trails, ideal for peaceful walks, photography, and experiencing rural Maharashtra’s serene environment."
  },
  {
    "title": "Community Halls and Gathering Spaces",
    "description": "Community halls in Kurkumbh host social, cultural, and religious gatherings, serving as focal points for village activities and celebrations."
  }
]
,



"services": [
  {
    "name": "Cab Service in Kurkumbh MIDC",
    "description": "Cab Service in Kurkumbh MIDC provides reliable and professional transportation solutions for residents, workers, and corporate travelers in and around Kurkumbh Industrial Area. Well-maintained vehicles, experienced chauffeurs, and flexible routes ensure timely pickups, comfortable rides, and smooth travel for industrial, corporate, and personal needs."
  },
  {
    "name": "Taxi Service Kurkumbh",
    "description": "Taxi Service Kurkumbh offers dependable taxi solutions for local and intercity travel. Whether commuting to work, attending meetings, or visiting nearby towns, passengers enjoy comfort, safety, and punctual service from trained drivers and clean, well-equipped vehicles."
  },
  {
    "name": "AC Cab Kurkumbh MIDC",
    "description": "AC Cab Kurkumbh MIDC ensures a cool and comfortable ride for employees and visitors traveling in Kurkumbh Industrial Area. Fully air-conditioned vehicles with spacious interiors provide a relaxing journey for daily commutes, industrial visits, and corporate travel."
  },
  {
    "name": "Industrial Cab Service Kurkumbh",
    "description": "Industrial Cab Service Kurkumbh specializes in transporting factory and industrial employees safely and efficiently. Scheduled pickups, professional drivers, and well-maintained vehicles guarantee punctual arrivals and stress-free travel for the workforce."
  },
  {
    "name": "Employee Transport Cab Kurkumbh",
    "description": "Employee Transport Cab Kurkumbh offers organized and reliable daily transportation for company employees. Air-conditioned cabs, trained chauffeurs, and fixed or flexible routes ensure comfort, safety, and timely arrival for office staff."
  },
  {
    "name": "Corporate Cab Kurkumbh",
    "description": "Corporate Cab Kurkumbh provides professional and efficient transportation solutions for business executives, corporate clients, and office staff. Ideal for daily commutes, client visits, and corporate events, this service focuses on reliability, comfort, and punctuality."
  },
  {
    "name": "Affordable Cab Kurkumbh",
    "description": "Affordable Cab Kurkumbh delivers budget-friendly cab services without compromising on comfort or safety. Suitable for small businesses, employees, and local travelers, it ensures dependable travel at competitive pricing for daily and occasional trips."
  },
  {
    "name": "Chauffeur Driven Cab Kurkumbh",
    "description": "Chauffeur Driven Cab Kurkumbh provides a stress-free travel experience with professional drivers handling navigation, traffic, and routes. Perfect for corporate travelers, industrial employees, and long-distance commuters, this service emphasizes safety, convenience, and comfort."
  },
  {
    "name": "Best Cab Service Kurkumbh",
    "description": "Best Cab Service Kurkumbh ensures top-quality transportation with well-maintained vehicles, trained drivers, and punctual service. Suitable for corporate clients, industrial employees, and private travelers, it offers a reliable and comfortable commuting solution."
  },
  {
    "name": "Outstation Cab Kurkumbh",
    "description": "Outstation Cab Kurkumbh provides long-distance travel options from Kurkumbh MIDC to nearby cities and towns. Fully air-conditioned vehicles, professional chauffeurs, and flexible scheduling make it ideal for corporate trips, family visits, and business travel."
  },
  {
    "name": "Factory Pickup Cab",
    "description": "Factory Pickup Cab offers safe and timely transportation for industrial employees from Kurkumbh MIDC factories to homes and workplaces. Scheduled routes, experienced drivers, and comfortable vehicles ensure smooth daily commutes for the workforce."
  },
  {
    "name": "Online Cab Booking Kurkumbh",
    "description": "Online Cab Booking Kurkumbh allows users to reserve cabs easily via a web or mobile platform. Flexible pickup locations, instant confirmations, and a choice of cab types make corporate and personal travel convenient and hassle-free."
  },
  {
    "name": "Business Travel Cab",
    "description": "Business Travel Cab provides professional and dependable transportation for executives and employees traveling for meetings, industrial visits, or client appointments. Comfortable, air-conditioned vehicles with trained drivers ensure safe and timely arrivals."
  },
  {
    "name": "MIDC Transport Cab",
    "description": "MIDC Transport Cab focuses on serving the Kurkumbh Industrial Area with efficient, reliable, and organized transport solutions. Ideal for factories, offices, and employees, the service prioritizes punctuality, safety, and comfort for daily and intercity travel."
  },
  {
    "name": "Kurkumbh Travel Taxi",
    "description": "Kurkumbh Travel Taxi offers a complete transportation solution for local and outstation travel from Kurkumbh MIDC. From corporate trips and employee transport to industrial visits and personal travel, this service ensures a safe, comfortable, and dependable ride for all passengers."
  }
],
"tableData": [
  ["Cab Service in Kurkumbh MIDC", "Taxi Service Kurkumbh"],
  ["AC Cab Kurkumbh MIDC", "Industrial Cab Service Kurkumbh"],
  ["Employee Transport Cab Kurkumbh", "Corporate Cab Kurkumbh"],
  ["Affordable Cab Kurkumbh", "Chauffeur Driven Cab Kurkumbh"],
  ["Best Cab Service Kurkumbh", "Outstation Cab Kurkumbh"],
  ["Factory Pickup Cab", "Online Cab Booking Kurkumbh"],
  ["Business Travel Cab", "MIDC Transport Cab"],
  ["Kurkumbh Travel Taxi", "—"]
]
,

"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Kurkumbh MIDC with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services in Kurkumbh MIDC, ideal for commuting, factory shifts, employee transport, airport transfers, and local travel."
  },
  {
    "WhyChooseheading": "Clean and Well‑Maintained Cabs",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced cabs that ensure a smooth and comfortable ride throughout Kurkumbh MIDC and nearby areas."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with Kurkumbh MIDC routes, ensuring safe and timely travel for all your cab needs."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront and clear pricing for cab services in Kurkumbh MIDC, including fuel, tolls, and driver allowances without any hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose from immediate bookings, advance reservations, one‑way, round‑trip, or hourly cab services based on your requirements in Kurkumbh MIDC."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every ride to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for cab services in Kurkumbh MIDC."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Kurkumbh MIDC?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable cab services in Kurkumbh MIDC for local commuting and other travel needs.'
  },
  {
    question: 'How can I book a cab in Kurkumbh MIDC?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available in Kurkumbh MIDC?',
    answer: 'Sanavi Travels provides hatchbacks, sedans, SUVs, and premium cars to suit your travel preferences.'
  },
  {
    question: 'Are drivers experienced with Kurkumbh MIDC routes?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with local and nearby routes for safe and timely travel.'
  },
  {
    question: 'Can I book a cab for airport transfers from Kurkumbh MIDC?',
    answer: 'Absolutely! We offer airport pickup and drop services to and from Kurkumbh MIDC.'
  },
  {
    question: 'Is cab service available 24x7 in Kurkumbh MIDC?',
    answer: 'Yes, Sanavi Travels provides round‑the‑clock cab services in Kurkumbh MIDC.'
  },
  {
    question: 'Are the cabs sanitized before every ride?',
    answer: 'Yes, all our vehicles are thoroughly cleaned and sanitized before each trip.'
  },
  {
    question: 'What payment options are available for cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and cash payments.'
  },
  {
    question: 'Is customer support available during the ride?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab journey in Kurkumbh MIDC.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Manoj Patil',
    feedback: 'Booked a cab in Kurkumbh MIDC. Comfortable ride, punctual driver, and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Shweta Deshmukh',
    feedback: 'Very reliable cab service in Kurkumbh MIDC. Smooth travel experience and supportive customer care.',
    rating: 5
  }
];



















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kurkumbh MIDC - Sanavi Travels",
  "description": "Sanavi Travels offers cab services in Kurkumbh MIDC for industrial transport, employee commuting, corporate travel, and factory pickups. AC, chauffeur-driven, and affordable cabs available with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "190"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Cab Service in Kurkumbh MIDC | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book cab service in Kurkumbh MIDC with Sanavi Travels for industrial transport, employee commuting, corporate travel, and factory pickups. AC, chauffeur-driven, and affordable cabs available with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/101.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinkurkumbhmidc;